module.exports = __webpack_public_path__ + "img/natural@2x.e7e5e51.webp";